import { Row, Col, Form, Input, Select, SelectOption } from "@ir/ui";

const UnfiPortalFormContent = ({
  getDisputeTypes,
  isDisputeTypesLoading,
  isSingleDisputeType,
}: {
  getDisputeTypes: () => SelectOption[];
  isDisputeTypesLoading: boolean;
  isSingleDisputeType: boolean;
}) => {
  return (
    <>
      <Row className="d-none">
        <Col span={12} md={12}>
          <Form.Item name="disputeType" rules={[{ required: true, message: "Dispute Type is required." }]} label="Dispute Type">
            <Select
              maxMenuHeight={150}
              className="select-field"
              placeholder="Select"
              options={getDisputeTypes()}
              isClearable={false}
              isLoading={isDisputeTypesLoading}
              isDisabled={isSingleDisputeType}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={12} md={6}>
          <Form.Item
            name="disputeAmount"
            dependencies={["totalAmount"]}
            rules={[
              { required: true, message: "Dispute Amount is required." },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  const totalAmount = getFieldValue("totalAmount");
                  if (value && Number(totalAmount) && Number(value) > Number(totalAmount)) {
                    return Promise.reject(new Error("Dispute Amount cannot be greater than Total Amount."));
                  }
                  if (value && value.toString().split(".")[1]?.length > 2) {
                    return Promise.reject(new Error("Dispute Amount must have two decimal places."));
                  }
                  return Promise.resolve();
                },
              }),
            ]}
            label="Dispute Amount"
          >
            <Input type="number" step="0.01" placeholder="Enter dispute amount" />
          </Form.Item>
        </Col>
        <Col span={12} md={6}>
          <Form.Item
            name="totalAmount"
            rules={[
              { required: true, message: "Total Amount is required." },
              () => ({
                validator(_, value) {
                  if (value && value.toString().split(".")[1]?.length > 2) {
                    return Promise.reject(new Error("Total Amount must have two decimal places."));
                  }
                  return Promise.resolve();
                },
              }),
            ]}
            label="Total Amount"
          >
            <Input type="number" placeholder="Total amount" isDisabled />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default UnfiPortalFormContent;
